
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import Tooltip from "@mui/material/Tooltip";
import {
  Typography,
  Modal,
  Box,
} from "@mui/material";
import { redirect } from "react-router-dom";
import { useState, useContext } from "react";
import { CognitoUserContext } from "../contexts/cognitoUserContext.js";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Success() {
    const { setCognitoUser } =
    useContext(CognitoUserContext);
  const [modalOpen, setModalOpen] = useState(true);
  const nav = useNavigate();
  // The call below should somehow reload the cognitoUser Attributes
  const handleModalClose = () => {
    setModalOpen(false);
    loader();
    // Does the nav but nothing in the home triggers any events
    nav("/");
  };
  const loader = async () => {
    const user = await Auth.currentAuthenticatedUser({ bypassCache: true })
    setCognitoUser(user); // Update context with refreshed user attributes
      return redirect("/");
    
  };
  
  return (
    <div>
      <Modal open={modalOpen}>
        
        <Box>
          <Box sx={style}>
            <Typography id="spring-modal-title" variant="h6" component="h2">
              We're sorry you didn't complete your subscription
            </Typography>
            <Typography id="spring-modal-title" variant="h6" component="h2">
              Everything will remain a little blurred
            </Typography>
            

            <Tooltip title="Subscription not complete...">
              <IconButton sx={{ color: "red" }} onClick={handleModalClose}>
                <CloseIcon />
              </IconButton>
            </Tooltip>
          </Box>

          <SubscriptionsIcon />
        </Box>
      </Modal>
    </div>
  );
}
export default Success;
